'use client'

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid'
import { TargetLanguageCode } from 'deepl-node'
import { parseAsBoolean, useQueryState } from 'nuqs'
import { useContext } from 'react'
import { TargetLanguage } from '../translate/types'
import { ThemeContext } from './theme'
import { getColor } from '../translate/util/color'

const DisplayNames: Record<string, string> = {
    'English (American)': 'English',
    'Portuguese (Brazilian)': 'Portuguese',
}
type Props = { ordered: TargetLanguageCode[]; langOrder: TargetLanguage[] }
const LangTagsDemo = ({ ordered, langOrder }: Props) => {
    const [langName, setShowLangName] = useQueryState('langName', parseAsBoolean)
    const { colors } = useContext(ThemeContext)
    // const activeOrdered = ordered.filter((lang) => tl.includes(lang))
    return (
        <div className="flex flex-wrap gap-1 overflow-auto">
            {ordered.map((lang) => {
                const isActive = true // tl.includes(lang)
                const colorIndex = ordered.indexOf(lang)
                const bg = colors[colorIndex]
                const backgroundColor = isActive ? bg : ''
                return (
                    <span
                        key={lang}
                        className={`md:text-md btn btn-sm text-sm`}
                        style={{
                            color: isActive ? getColor(bg) : undefined,
                            backgroundColor,
                        }}
                        onClick={() => {}}
                    >
                        {langName ? lang : getFullLanguageName()}
                    </span>
                )

                function getFullLanguageName() {
                    const name = langOrder.find((l) => l.code === lang)!.name
                    return DisplayNames[name] || name
                }
            })}
            <button className={`btn btn-primary btn-sm`}>+</button>
            <button
                className={`btn btn-primary btn-sm`}
                onClick={() => {
                    setShowLangName(!langName)
                }}
            >
                {langName ? <ChevronRightIcon height={12} /> : <ChevronLeftIcon height={12} />}
            </button>
        </div>
    )
}

export default LangTagsDemo
